import Icon from 'veui/components/Icon'
import { IconApps } from 'dls-icons-vue'

Icon.register('apps', IconApps)
